import { useFlagsContext } from '../contexts/FlagsProvider'
import { createNadDebug } from '../utils/debugLog'

// RFC-0856 I10: OpenFeature-compatible reactive flag readers (in-house). The
// signatures match OpenFeature's `use{Boolean,String,Number}FlagValue(key,
// default)` so a later swap to the real SDK is drop-in. Values are narrowed with
// `typeof` (the wire value is untrusted JSON) — a missing key or type mismatch
// falls back to the caller-supplied default. Re-renders automatically when the
// snapshot refreshes (react-query updates the context).
const flagReadLog = createNadDebug('dw:feature-flags-client:client')

export function useBooleanFlagValue(key: string, defaultValue: boolean): boolean {
  const { flags } = useFlagsContext()
  const value = flags[key]
  const resolved = typeof value === 'boolean' ? value : defaultValue
  flagReadLog({
    event: 'feature-flags-client:flag_read',
    feature: 'feature-flags-client',
    concern: 'client',
    key,
    resolved,
  })
  return resolved
}

export function useStringFlagValue(key: string, defaultValue: string): string {
  const { flags } = useFlagsContext()
  const value = flags[key]
  return typeof value === 'string' ? value : defaultValue
}

export function useNumberFlagValue(key: string, defaultValue: number): number {
  const { flags } = useFlagsContext()
  const value = flags[key]
  return typeof value === 'number' ? value : defaultValue
}
